import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Typography from "../../Typography";
import styles from "./appDownload.module.scss";

const APP_LINKS = [
    {
        name: "Google Play",
        icon: new URL("../../../img/appstores/google-play.svg", import.meta.url).href,
    },
    {
        name: "App Store",
        icon: new URL("../../../img/appstores/app-store.svg", import.meta.url).href,
    },
    {
        name: "App Gallery",
        icon: new URL("../../../img/appstores/app-gallery.svg", import.meta.url).href,
    },
];

const driverTirIcon = new URL("../../../img/footer/drivertir.svg", import.meta.url).href;

const AppDownload = () => {
    const { t } = useTranslation();

    const handleClick = () => {
        toast.info(t("footer.appComingSoon"));
    };

    return (
        <div className={styles.root}>
            <Typography variant="body2" weight="bold" className={styles.title}>
                {t("footer.appDownloadTitle")}
            </Typography>
            <div className={styles.buttons}>
                {APP_LINKS.map((link) => (
                    <button
                        key={link.name}
                        type="button"
                        onClick={handleClick}
                        className={styles.button}
                    >
                        <img src={link.icon} alt={link.name} className={styles.icon} />
                        <span className={styles.label}>{link.name}</span>
                    </button>
                ))}
            </div>
            <Typography variant="body2" weight="bold" className={styles.driverTitle}>
                {t("footer.forDrivers")}
            </Typography>
            <div className={styles.buttons}>
                <a
                    href="https://drivertir.com?blago-footer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.button}
                >
                    <img src={driverTirIcon} alt="DriverTIR" className={styles.icon} />
                    <span className={styles.label}>DriverTIR</span>
                </a>
            </div>
        </div>
    );
};

export default AppDownload;